import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ds from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import {
  Button,
  Row,
  Col,
  Spin,
  Form,
  Avatar,
  Popover,
  List,
  Tag,
  Tabs
} from 'antd'
import moment from 'moment'
import CustomScrollbars from '../../util/CustomScrollbars'
import Placeholder from '../../assets/images/placeholder.svg'
import {
  loadCurrentSalesOrderData,
  loadCurrentOrderGuidID,
  loadSellSelectedAttributes,
  loadSellAttributeLoading,
  loadSellAttributes,
  loadSellAttribTabs,
  loadSellAttribTabs_type
} from '../../appRedux/actions/Sell'
import { loadPreventSellRunnerExecution } from '../../appRedux/actions/MainSale'
import {
  fetchCurrentSalesOrder,
  getDecryptID,
  isEmptyObject,
  loadIncomingSale,
  notAllowMsgCheck,
  saleIsInProgress,
  setDiscCurrPerNote
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { RollbackOutlined } from '@ant-design/icons'
import ParkRetrieveListItem from './ParkRetrieveListItem'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { ATTRIB_MODAL_TYPES } from '../../constants/MobAppConstants'

const listData = []
for (let i = 0; i < 20; i++) {
  listData.push({
    href: 'http://ant.design' + '' + '',
    title: `Ant design part ${i}`,
    avatar: 'https://via.placeholder.com/290X193',
    description:
      'Ant Design, a design language for background applications, is refined by Ant UED Team.',
    content:
      'We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.'
  })
}

const RetrieveSale = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const { TabPane } = Tabs

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const AllStatus = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getConfigSellAttribute = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellAttribute
  )
  const sellAttributesGroups = useSelector(
    ({ Sell }) => Sell.sellAttributesGroups
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getIsSpinning, setIsSpinning] = useState(false)
  const [getRetriveSaleData, setRetriveSaleData] = useState([])
  const [getRetOfflineSaleData, setRetOfflineSaleData] = useState([])
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getCurrentPageNo, setCurrentPageNo] = React.useState(1)
  const [getSelectedTab, setSelectedTab] = React.useState(isOnline ? '1' : '2')
  const [getPageSize, setPageSize] = React.useState(10)
  const [getOfflineClick, setOfflineClick] = React.useState(false)
  const [getOfflineLoader, setOfflineLoader] = React.useState(false)
  const [getTotalRecords, setTotalRecords] = React.useState(1)
  const [getIsParkeSalePopoverVisible, setIsParkeSalePopoverVisible] =
    React.useState(false)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getReduxSelectedStoreOutlets.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          setSelectedOutlet(
            getReduxSelectedStoreOutlets.id
              ? getReduxSelectedStoreOutlets.id
              : selectedLocalOut.id
          )
        }
      }

      // //;
    }
    return () => (mounted = false)
  }, [getReduxSelectedStoreOutlets])

  async function getDetailService (body, dataOffline) {
    setIsSpinning(true)
    const getSaleHistoryByID = ds.getSaleHistoryByIdService(
      body,
      BEHAVIOUR_TYPE.GET
    )
    await getSaleHistoryByID
      .then(res => {
        setIsSpinning(false)
        if (res && res.length > 0) {
          //marking to identify that the prods coming first time from backend
          res.map(q => {
            if (q.products && q.products.length > 0) {
              q.products.map(a => (a.firstTime = true))
            }
          })

          if (dataOffline && dataOffline.length > 0) {
            dataOffline.map(qw => {
              res = res.filter(ee => ee.indexKey != qw.indexKey)
            })
            // res = res.filter(q =>
            //   dataOffline.some(a => q.indexKey != a.indexKey)
            // )
          }
          setRetriveSaleData(res)
          let getRetriveSale = res
          let totalRecords = !isEmptyObject(getRetriveSale)
            ? getRetriveSale[0].totalRecords
            : 0
          setTotalRecords(totalRecords)
        } else {
          setRetriveSaleData([])
          setTotalRecords(1)
        }
      })
      .catch(e => {
        setRetriveSaleData([])
        setTotalRecords(1)
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }
  const handleClickRetrieveSell = isOffline => {
    // setIsSpinning(true)
    if (isOnline && !isOffline) {
      let outletID = getSelectedOutlet
      let body = {
        OutletID: outletID,
        SalesOrderID: '',
        SalesOrderStatusID: fetchCurrentSalesOrder('Parked'),
        CustomerID: '',
        UserID: '',
        CurrentPageNo: getCurrentPageNo,
        PageSize: getPageSize,
        IsRetrieve: true
      }
      fetchRetrieveFromIndex(true, body)
      // getDetailService(body)
    } else {
      fetchRetrieveFromIndex()
    }
  }

  function fetchRetrieveFromIndex (onlyOffline, body) {
    setOfflineLoader(true)
    if (body) {
      setIsSpinning(true)
    }
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        setOfflineLoader(false)
        let data = []
        if (e && e.length > 0) {
          let parkedSales = e.filter(
            q =>
              getDecryptID(q.e_SalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('Parked')) && q.isParked
            // &&
            // q.isOffline
          )
          if (parkedSales && parkedSales.length > 0) {
            if (onlyOffline) {
              parkedSales = parkedSales.filter(q => q.isOffline)
            }
            //marking to identify that the prods coming first time from backend
            parkedSales.map(q => {
              if (q.products && q.products.length > 0) {
                q.products.map(a => (a.firstTime = true))
              }
            })
            parkedSales.sort((x, y) => {
              if (x.operateDateTime && y.operateDateTime) {
                const momentA = moment(x.operateDateTime)
                const momentB = moment(y.operateDateTime)

                if (momentA.isAfter(momentB)) {
                  return -1 // a should come before b in the sorted order
                } else if (momentA.isBefore(momentB)) {
                  return 1 // a should come after b in the sorted order
                } else {
                  return 0 // timestamps are equal
                }
              }
            })
            parkedSales.map(a => {
              data.push(a)
            })
            // setRetriveSaleData(parkedSales)
            // setTotalRecords(parkedSales.length)
          }
        }
        if (data && data.length > 0) {
          // setRetriveSaleData(data)
          setRetOfflineSaleData(data)
          // setTotalRecords(data.length)
        } else {
          // setRetriveSaleData([])
          setRetOfflineSaleData([])
          // setTotalRecords(1)
        }

        if (body) {
          getDetailService(body, data)
        }
      })
      .catch(e => {
        if (body) {
          getDetailService(body)
        }
        // setRetriveSaleData([])
        setRetOfflineSaleData([])
        // setTotalRecords(1)
        setOfflineLoader(false)
        console.log(
          'INDEX_DB_ERROR -> fetchRetrieveFromIndex, index api call SALES -->',
          e
        )
      })
  }

  // const handleClickParkedItem = selectedParkedSaleData => {
  //   if (!isEmptyObject(selectedParkedSaleData)) {
  //     if (!isEmptyObject(getCurrentSalesOrderData)) {
  //       saleIsInProgress(dispatch, selectedParkedSaleData)
  //     } else {
  //       loadIncomingSale(selectedParkedSaleData, dispatch)
  //     }
  //   }
  //   setIsParkeSalePopoverVisible(false)
  // }

  // function onTabChange (key) {
  //   if (key == 1) {
  //     setSelectedTab(`${key}`)
  //     handleClickRetrieveSell(false)
  //   } else if (key == 2) {
  //     setSelectedTab(`${key}`)
  //     handleClickRetrieveSell(true)
  //   }
  // }

  const pagination = {
    pageSize: getPageSize,
    current: getCurrentPageNo,
    total: getTotalRecords,
    // defaultPageSize: 10,
    hideOnSinglePage: true,
    // onChange: () => {},
    onChange: page => {
      setCurrentPageNo(page)
      // setIsSpinning(true)
      let outletID = getSelectedOutlet
      let body = {
        OutletID: outletID,
        SalesOrderID: '',
        SalesOrderStatusID: AllStatus.filter(a => a.StatusName == 'Parked')[0]
          .SalesOrderStatuID,
        CustomerID: '',
        UserID: '',
        CurrentPageNo: page,
        PageSize: getPageSize
      }
      fetchRetrieveFromIndex(true, body)
      // getDetailService(body)
    }
  }

  const ListView = props => {
    const { type } = props
    return (
      <CustomScrollbars className='gx-module-content-scroll'>
        {isOnline && (
          <List
            itemLayout='horizontal'
            pagination={isOnline && getSelectedTab == '1' ? pagination : false}
            // pagination={isOnline && type == 'online' ? pagination : false}
            dataSource={getRetriveSaleData}
            renderItem={retrieveItem => {
              return (
                <ParkRetrieveListItem
                  retrieveItem={retrieveItem}
                  callBack={callBack}
                  type='retrieve'
                />
              )
            }}
          />
        )}

        {getRetOfflineSaleData && getRetOfflineSaleData.length > 0 && (
          <>
            <h2 style={{ marginLeft: 10, marginBottom: -6 }}>
              <strong>OFFLINE SALES:</strong>
            </h2>
            <Spin
              tip={<IntlMessages id='sell.cashlisting.cashloading' />}
              spinning={getOfflineLoader} //getIsSpinning
              size='large'
            >
              {getRetOfflineSaleData.map(qq => {
                return (
                  <ParkRetrieveListItem
                    retrieveItem={qq}
                    callBack={callBack}
                    type='retrieve'
                  />
                )
              })}
            </Spin>
          </>
        )}
      </CustomScrollbars>
    )
  }

  // const RetrieveSaleContent = () => {
  //   return (
  //     <Spin
  //       tip={<IntlMessages id='sell.cashlisting.cashloading' />}
  //       spinning={getIsSpinning} //getIsSpinning
  //       size='large'
  //     >
  //       <Tabs
  //         // style={{ marginTop: -18 }}
  //         defaultActiveKey={isOnline ? '1' : '2'}
  //         size='large'
  //         onChange={onTabChange}
  //         activeKey={getSelectedTab}
  //       >
  //         <TabPane
  //           style={{ fontWeight: 'bold' }}
  //           tab={<IntlMessages id='sell.park.online' />}
  //           key={'1'}
  //           disabled={!isOnline}
  //         >
  //           <ListView />
  //         </TabPane>
  //         <TabPane
  //           style={{ fontWeight: 'bold' }}
  //           tab={<IntlMessages id='sell.park.offline' />}
  //           key={'2'}
  //         >
  //           {getRetriveSaleData && getRetriveSaleData.length > 0 && (
  //             <h3 style={{ marginLeft: 10 }}>
  //               NOTE: These sales will be moved to Online when Internet is
  //               available
  //             </h3>
  //           )}
  //           <ListView />
  //         </TabPane>
  //       </Tabs>
  //     </Spin>
  //   )
  // }

  const RetrieveSaleContent = () => {
    return (
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getIsSpinning} //getIsSpinning
        size='large'
      >
        <ListView />
      </Spin>
    )
  }

  const RetrieveSaleTitle = (
    <>
      <Row justify='center'>
        <Col span={24}>
          <h2 className='mb-2 mt-2'>
            {' '}
            <IntlMessages id='sell.sell.parkedsale' />{' '}
          </h2>
        </Col>
      </Row>
    </>
  )

  function callBack () {
    setIsParkeSalePopoverVisible(false)
  }

  return (
    <>
      {getDecryptID(getCurrentSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
      getDecryptID(getCurrentSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('On Account')) ||
      getDecryptID(getCurrentSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('Delivery, unfulfilled')) ||
      getDecryptID(getCurrentSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('PickUp, unfulfilled')) ? (
        <Button
          className=''
          icon={<RollbackOutlined className='dk-btn-icon-align' />}
          disabled={true}
        >
          <IntlMessages id='sell.sell.retrieve' />
          <span className='dk-text-hide-on-mobile'>
            <IntlMessages id='sell.sell.sale' />
          </span>
        </Button>
      ) : (
        <Popover
          placement='bottom'
          title={RetrieveSaleTitle}
          content={RetrieveSaleContent}
          trigger='click'
          visible={getIsParkeSalePopoverVisible}
          overlayClassName='dk-width-popover'
          onVisibleChange={e => {
            if (
              getConfigSellAttribute &&
              sellAttributesGroups &&
              sellAttributesGroups.length > 0
            ) {
              dispatch(loadSellAttributeLoading(true))
              dispatch(
                loadSellAttributes(
                  {
                    GroupID: sellAttributesGroups[0].groupID
                      ? sellAttributesGroups[0].groupID
                      : '',
                    OutletID: getSelectedOutlet
                  },
                  isOnline
                )
              )
              dispatch(loadSellAttribTabs(true))
              dispatch(
                loadSellAttribTabs_type(ATTRIB_MODAL_TYPES.RETRIEVE_SALE)
              )
            } else {
              if (e) {
                if (isOnline) {
                  handleClickRetrieveSell(false) // getSelectedTab == '1' ? false : true
                } else {
                  setSelectedTab('2')
                  handleClickRetrieveSell(true)
                }
              }
              setIsParkeSalePopoverVisible(!getIsParkeSalePopoverVisible)
            }
          }}
        >
          <Button
            className=''
            // onClick={() => handleClickRetrieveSell()}
            icon={<RollbackOutlined className='dk-btn-icon-align' />}
            // disabled={
            //   getDecryptID(getCurrentSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
            //   getDecryptID(getCurrentSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder('On Account')) ||
            //   getDecryptID(getCurrentSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder('Delivery, unfulfilled')) ||
            //   getDecryptID(getCurrentSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder('PickUp, unfulfilled'))
            //     ? true
            //     : false
            // }
          >
            <IntlMessages id='sell.sell.retrieve' />
            <span className='dk-text-hide-on-mobile'>
              <IntlMessages id='sell.sell.sale' />
            </span>
          </Button>
        </Popover>
      )}
    </>
  )
}

export default RetrieveSale
